<template>
  <div class="flex space-x-1 ">
    <div
      :class="style"
      class="text-white h-3 w-3 my-auto"
    ></div>
    <div class="">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['status'],
  computed: {
    style() {
      if (this.status === 'ATIVO') {
        return 'bg-blue-600';
      }

      return 'bg-red-700';
    }
  }

}
</script>

<style scoped>
</style>
